"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
// NOTE: this icon is only used here, therefore co-located.
var IconAsterisk = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M8 0a1 1 0 0 1 1 1v5.268l4.562-2.634a1 1 0 1 1 1 1.732L10 8l4.562 2.634a1 1 0 1 1-1 1.732L9 9.732V15a1 1 0 1 1-2 0V9.732l-4.562 2.634a1 1 0 1 1-1-1.732L6 8 1.438 5.366a1 1 0 0 1 1-1.732L7 6.268V1a1 1 0 0 1 1-1z" }))); };
var Label = function (_a) {
    var children = _a.children, text = _a.text, position = _a.position, className = _a.className, error = _a.error, isRequired = _a.isRequired, containerClassName = _a.containerClassName, props = __rest(_a, ["children", "text", "position", "className", "error", "isRequired", "containerClassName"]);
    var child = React.Children.only(children);
    // NOTE: generate a random number and make it constant by setting to a ref (otherwise changes ID on each render)
    // The purpose of this is to take care of the id + htmlFor connection that must happen between labels and associated components.
    var htmlFor = React.useRef("__".concat(Math.floor(Math.random() * 10000000 + 1).toString()));
    var baseCns = (0, classnames_1.default)('br-block', 'br-text-base', { 'br-text-red-600': Boolean(error) });
    var asterisk = isRequired ? (React.createElement("sup", null,
        React.createElement(IconAsterisk, { className: (0, classnames_1.default)('br-h-2', 'br-w-2'), style: { marginLeft: '0.1rem' } }))) : null;
    var labelText = null;
    if (text) {
        labelText = (React.createElement("div", { className: (0, classnames_1.default)('br-flex', 'br-items-center') },
            text,
            asterisk));
    }
    if (position === 'right') {
        return (React.createElement("div", { className: (0, classnames_1.default)('br-flex', 'br-items-center', containerClassName) },
            React.isValidElement(child) && React.cloneElement(child, __assign({ id: htmlFor.current }, child.props)),
            text && (React.createElement("label", __assign({ htmlFor: htmlFor.current, className: (0, classnames_1.default)(baseCns, 'br-pl-2', className) }, props), labelText))));
    }
    // Default position is "top", so return this one if nothing else specified.
    return (React.createElement("div", { className: (0, classnames_1.default)('br-flex', 'br-flex-col', containerClassName) },
        text && (React.createElement("label", __assign({ htmlFor: htmlFor.current, className: (0, classnames_1.default)(baseCns, 'br-pb-1', className) }, props), labelText)),
        React.isValidElement(child) && React.cloneElement(child, __assign({ id: htmlFor.current }, child.props))));
};
exports.Label = Label;
